import { render, staticRenderFns } from "./label.vue?vue&type=template&id=17083098&lang=html"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports